import React, {useState} from "react";
import {
  Box,
  IconButton,
  Table, TableBody, TableCell, TableHead, TableRow,
  Tooltip,
  Typography
} from "@mui/material";
import {menuItemsInfo} from "../editMenuItems";
import {IconPencil, IconPlus} from "@tabler/icons-react";
import {CreateVariableModal} from "../settings/CreateVariableModal";

export const InputParamsTab = ({node, onUpdate, project}) => {
  const {primary, secondary} = menuItemsInfo.input_params;
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  return (
    <>
      <CreateVariableModal
        open={open}
        handleClose={() => {
          setOpen(false);
          setSelected(null);
        }}
        project={project}
        editParam={selected} isForm={!!node?.data?.form_id}
        onUpdateParams={(newParams) => {
          console.log(newParams);
          const newNode = {...node};
          newNode.data.inputs = newParams || [];
          onUpdate(newNode)
        }}
        params={node?.data?.inputs || []}
      />
      <Box sx={{borderBottom: 1, borderColor: "divider", pb: 0.5}}>
        <Typography fontWeight={700} sx={{pb: 1}}>{primary}</Typography>
        <Typography variant={"body2"} fontSize={13}>{secondary}</Typography>
      </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{fontWeight: 600, fontSize: 13, py: 1, px: 0.5}}>From</TableCell>
            <TableCell sx={{fontWeight: 600, fontSize: 13, py: 1, px: 0.5}}>Target</TableCell>
            <TableCell padding={"checkbox"} sx={{fontWeight: 600, fontSize: 13, width: "auto"}}>
              <Tooltip title={"Add new variable"}>
                <IconButton
                  variant={"outlined"}
                  size={"small"}
                  onClick={() => setOpen(true)}
                >
                  <IconPlus size={18} />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {node?.data?.inputs?.map((param, index) => {
            return (
              <TableRow key={`${param.uid}-${index}`}>
                <TableCell sx={{fontSize: 12, py: 1, px: 0.5}}>
                  ({param?.source_scope})  {param?.source}
                </TableCell>
                <TableCell sx={{fontSize: 12, py: 1, px: 0.5}}>
                  ({param?.target_scope})  {param?.target}
                </TableCell>
                <TableCell padding={"checkbox"} sx={{width: "auto"}}>
                  <IconButton
                    variant={"outlined"}
                    size={"small"}
                    fullWidth
                    onClick={() => {
                      setSelected(param);
                      setOpen(true)
                    }}
                  >
                    <IconPencil size={18}/>
                  </IconButton>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </>
  )
}